import { type Theme, styled, useTheme } from '@mui/material';
import { type SystemStyleObject } from '@mui/system';
import { merge } from 'lodash-es';
import { forwardRef } from 'react';
import ReactPlayer, { type Config } from 'react-player';
import { setResponsiveHeight } from '#helpers/setResponsiveHeight.ts';

export const Container = styled('div')({
  '.reactPlayer': {
    left: 0,
    position: 'absolute',
    top: 0,
  },
  height: 0,
  position: 'relative',
  width: '100%',
});

const baseConfig = {
  youtube: {
    playerVars: {
      autoplay: true,
      controls: true,
    },
  },
};

export type TrailerPlayerProps = {
  autoplay?: boolean;
  config?: Config;
  height?: string;
  responsiveHeights?: {
    lg?: string;
    md?: string;
    sm?: string;
    xl?: string;
    xs?: string;
  };
  sx?: SystemStyleObject<Theme>;
  url: string[];
};

// Doesn't matter
// eslint-disable-next-line react/display-name
export const TrailerPlayer = forwardRef<HTMLDivElement, TrailerPlayerProps>(
  ({ config, height = '56.25%', responsiveHeights, sx, url }, ref) => {
    const theme = useTheme();

    return (
      <Container
        ref={ref}
        sx={{
          ...sx,
          paddingBottom: height,
          ...(responsiveHeights ? setResponsiveHeight(theme, responsiveHeights) : undefined),
        }}
      >
        {/* @ts-expect-error types are wrong in react-player */}
        <ReactPlayer
          className="reactPlayer"
          config={merge({}, baseConfig, config)}
          height="100%"
          // TODO: ReactPlayer has a bug that causes an array of urls to break the player
          url={url[0]}
          width="100%"
        />
      </Container>
    );
  },
);
